module.exports = __webpack_public_path__ + "img/sample1.21578297.png";